var showUI = (typeof window !== 'undefined');

var ui_extensions = showUI ? require("ui-extensions") : {};
var lib_core  = require("lib-core");

var SelectionController = require("./../selection/selectionController.js");
var Editor2DController = require("./../editor2D/editor2DController.js");

var AlignmentStateMachine = require("./alignmentStateMachine.js");

var AlignmentController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);
    lib_core.GuiEvents.addEvents({
        ALIGNMENT_HORIZONTAL_LEFT_BUTTON    : {id: 'align_1', name: "ALIGNMENT_HORIZONTAL_LEFT_BUTTON" },
        ALIGNMENT_HORIZONTAL_CENTER_BUTTON  : {id: 'align_2', name: "ALIGNMENT_HORIZONTAL_CENTER_BUTTON" },
        ALIGNMENT_HORIZONTAL_RIGHT_BUTTON   : {id: 'align_3', name: "ALIGNMENT_HORIZONTAL_RIGHT_BUTTON" },
        ALIGNMENT_VERTICAL_BOTTOM_BUTTON    : {id: 'align_4', name: "ALIGNMENT_VERTICAL_BOTTOM_BUTTON" },
        ALIGNMENT_VERTICAL_CENTER_BUTTON    : {id: 'align_5', name: "ALIGNMENT_VERTICAL_CENTER_BUTTON" },
        ALIGNMENT_VERTICAL_TOP_BUTTON       : {id: 'align_6', name: "ALIGNMENT_VERTICAL_TOP_BUTTON" },
        DISTRIBUTE_VERTICAL                 : {id: 'distribute_1', name: "DISTRIBUTE_VERTICAL" },
        DISTRIBUTE_HORIZONTAL               : {id: 'distribute_2', name: "DISTRIBUTE_HORIZONTAL" },
    });
};
lib_core.inherit(AlignmentController, lib_core.Controller);
AlignmentController.inject = {
    editor2DController  : Editor2DController,
    SelectionController : SelectionController,
    tabController       : showUI ? ui_extensions.TabController : undefined
};

module.exports = AlignmentController;

AlignmentController.prototype.createStateMachine = function () {
    var selectionModel = this.SelectionController.getModel();
    return new AlignmentStateMachine(this.root, selectionModel.selection);
};

AlignmentController.prototype.afterBuild = function () {
    this.parent().getModel().addInspectorButtons([[
        {
            name: 'Align Selection Left',
            title: 'Align Selection Left',
            sortOrder: 50,
            eventType: lib_core.GuiEvents.ALIGNMENT_HORIZONTAL_LEFT_BUTTON,
            style: {
                icon: 'icon-align-left.svg',
            },
            group: "modifier"
        },
        {
            name: 'Align Selection Horizontally',
            title: 'Align Selection Horizontally',
            sortOrder: 51,
            eventType: lib_core.GuiEvents.ALIGNMENT_HORIZONTAL_CENTER_BUTTON,
            style: {
                icon: 'icon-align-horizontal.svg',
            },
            group: "modifier"
        },
        {
            name: 'Align Selection Right',
            title: 'Align Selection Right',
            sortOrder: 52,
            eventType: lib_core.GuiEvents.ALIGNMENT_HORIZONTAL_RIGHT_BUTTON,
            style: {
                icon: 'icon-align-right.svg',
            },
            group: "modifier"
        },
        {
            name: 'Align Selection Bottom',
            title: 'Align Selection Bottom',
            sortOrder: 53,
            eventType: lib_core.GuiEvents.ALIGNMENT_VERTICAL_BOTTOM_BUTTON,
            style: {
                icon: 'icon-align-bottom.svg',
            },
            group: "modifier"
        },
        {
            name: 'Align Selection Vertically',
            title: 'Align Selection Vertically',
            sortOrder: 54,
            eventType: lib_core.GuiEvents.ALIGNMENT_VERTICAL_CENTER_BUTTON,
            style: {
                icon: 'icon-align-vertical.svg',
            },
            group: "modifier"
        },
        {
            name: 'Align Selection Top',
            title: 'Align Selection Top',
            sortOrder: 55,
            eventType: lib_core.GuiEvents.ALIGNMENT_VERTICAL_TOP_BUTTON,
            style: {
                icon: 'icon-align-top.svg',
            },
            group: "modifier"
        }],
        [{
            name: 'Distribute Selection Horizontal',
            title: 'Distribute Selection Horizontal',
            sortOrder: 56,
            eventType: lib_core.GuiEvents.DISTRIBUTE_HORIZONTAL,
            style: {
                icon: 'icon-distribute-horizontal.svg',
            },
            group: "modifier"
        },
        {
            name: 'Distribute Selection Vertical',
            title: 'Distribute Selection Vertical',
            sortOrder: 57,
            eventType: lib_core.GuiEvents.DISTRIBUTE_VERTICAL,
            style: {
                icon: 'icon-distribute-vertical.svg',
            },
            group: "modifier"
        }]]);
};
